import axios from "axios";

const state = {
    NisStep:1,
    NIsItems:{},
};

const getters = {
    getNisStep(state){
        return state.NisStep
    },
    getNisItems(state){
        return state.NIsItems
    },
};

const mutations = {
    setNisStep(state, payload) {
    state.NisStep = payload;
  },
  setNisItems(state, payload){
      state.NIsItems=payload
  }
};

const actions = {

    NISAppValidationRequest({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/NISValidationRequest?appID=${payload.applicationID}`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setNisStep", 2);
            commit("setNisItems", res.data);
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  NisPayment({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/NISPaymentRequest?customerID=${payload.customerID}&pin=${payload.pin}&appID=${payload.applicationID}&location='WEBSITE'&imei='WEBSITE'`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setBalance",  res.data.updatedMainBalance );
            commit("setCommissionBalance",  res.data.updatedCommissionBalance );
            commit("setNisStep", 1);
            commit("getNisItems", {});
            //commit("setSnackbar", true);
            //commit("setServerMessage", res.data.message)
            payload.route.push({name: "Successful"})
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};








